import computeSimpleValue from "../percents/compute-simple-value";

/**
 *
 * @param {PropertyValueProps} item
 * @param {PropertyValueProps} initial
 * @param {Number} progress
 * @param {String} output
 * @param {Array<String | Array<String>>} numbers
 * @param {Array<String | Array<String>>} strings
 * @param {Boolean} isSafariInitial
 */
const computeSimpleValues = (
  item,
  initial,
  progress,
  output,
  numbers,
  strings,
  isSafariInitial
) => {
  switch (true) {
    /**
     * Property is inheritance (`?`)
     */
    case item.get("v_is-inherit"):
      if (initial.get("v_is-string")) {
        strings.push(item.get("v_output"));
      }

      if (initial.get("v_is-number")) {
        numbers.push(computeSimpleValue(progress, item, output, numbers, null));
      }
      break;

    /**
     * Property is string (`top`)
     */
    case item.get("v_is-string"):
      strings.push(progress > 0 ? item.get("v_output") : output);
      break;

    /**
     * Property is number (`2px`) default
     */
    default:
      numbers.push(
        computeSimpleValue(
          progress,
          item,
          output,
          numbers,
          null,
          isSafariInitial
        )
      );
      break;
  }
};

export default computeSimpleValues;
